import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarregaJetta {
  private lambdaEndpoint = 'https://du0btsv8a3.execute-api.sa-east-1.amazonaws.com/dev22';
  private lambdaEndpointCargaFechada = 'https://bwpfjgzf56.execute-api.sa-east-1.amazonaws.com/v1/';

  constructor(private http: HttpClient) { }


  async postCredentials(user: string, password: string): Promise<Observable<any>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    // Adicione o parâmetro 'tableName' ao objeto 'itemsData'
    const payload = {
      user,
      password
    };
    return await this.http.post<any>(this.lambdaEndpoint, payload, { headers: headers });
  }

  async getCargaFechada(user: string, password: string, minDate: string, maxDate: string): Promise<Observable<any>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    // console.log(minDate)
    // console.log(maxDate)
    // {
    //   "user": "usuario@dominio.com",
    //   "password": "senha123",
    //   "minDate": "2024-10-15",
    //   "maxDate": "2024-11-15"
    // }    
    const payload = {
      user,
      password,
      minDate,
      maxDate
    };
    // console.log(payload)
    return await this.http.post<any>(this.lambdaEndpointCargaFechada, payload, { headers: headers });
  }
}
